import { NAME as namespace } from './constants';
import { rubriqReducer as reducer } from './reducer';
export var rubriq = {
  namespace: namespace,
  reducer: reducer
};
export default rubriq;